<template>
  <div>
    <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
      <div>
        <v-badge :content="item.quantite_souhaite" inline></v-badge>
      </div>
      <div>
        <div class="text-body-1">{{ item.nom }}</div>
      </div>
      <div class="justify-self-end text-body font-weight-bold">
        <span v-if="item.current_price">{{ item.current_price }}€</span><span v-else>Gratuit</span>
      </div>
    </div>

    <div class="pl-4" v-for="size in selected_sizes" :key="size.id">
      {{ size.quantite_souhaite }}x <b>taille {{ size.nom }}</b>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    selected_sizes() {
      return this.item.sizes.filter((size) => size.quantite_souhaite > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail_cart {
  width: 50px;
  border-radius: 10px;
}
</style>